import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MainComponent } from './pages/main/main.component';
import { LandingComponent } from './pages/landing/landing.component';
import { LogoutComponent } from './pages/logout/logout.component';

const routes: Routes = [
  { path: 'index/authorize/callback', component: LandingComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'main', component: MainComponent },
  { path: '', component: LandingComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
